<template>
  <div class="d-flex">
    <navigator />
    <div class="surveys-container">
      <div class="title-header">
        <h2>Templates</h2>
      </div>
      <div class="inner-surveys-container">
        <SearchSurveys mode="template-edit" />
      </div>
    </div>
  </div>
</template>

<script>
import navigator from "../layout/NavBarNew.vue";
import SearchSurveys from "./SearchSurveys.vue";

export default {
  components: {
    navigator,
    SearchSurveys,
  },
  data() {
    return {
      userId: window.localStorage.getItem("userId"),
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester, 1: Company, 2: Admin
    };
  },
  mounted() {
    if (!this.userId || this.userType === -1) {
      this.$router.push({
        name: "login",
      });
    }
  },
};
</script>

<style scoped>
.surveys-container {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  margin: 0px 0px 0px auto;
  background-color: #EEEEEE;
}

.title-header {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  width: 100%;
  box-shadow: 0 4px 10px -6px grey;
}

.title-header h2 {
  color: #FF7222;
  font-weight: bold;
}

h4 {
  color: #FF7222;
  font-weight: bold;
  margin: 1rem 0px;
}

.inner-surveys-container {
  width: 100%;
  height: calc(100vh - 90px);
}
</style>



// WEBPACK FOOTER //
// src/components/survey-dashboard/Templates.vue